import React, { useState } from 'react';
import { View, TextInput, Text, StyleSheet, ActivityIndicator, TouchableOpacity, Alert } from 'react-native';
import { useRouter } from 'expo-router';
import OnboardingOverlay from '../Onboarding';
import { useLogin } from '@/services/auth/useLogin';

export default function LoginComponent() {
  const router = useRouter();
  const [username, setUsername] = useState('test');
  const [password, setPassword] = useState('test');
  const [loading, setLoading] = useState(false);
  const { login } = useLogin();

  const handleSignup = async () => {
    router.push({
      pathname: '/',
      params: { webViewURL: 'registrierung.html' },
    });
  }
  const handleForgotPassword = async () => {
    router.push({
      pathname: '/',
      params: { webViewURL: 'login.html?tx_felogin_login%5Baction%5D=recovery&tx_felogin_login%5Bcontroller%5D=PasswordRecovery&cHash=ad46ba52c261c4eb6333e963b7633c1a' },
    });
  }

  return (
    <View style={styles.container}>
      <OnboardingOverlay page="login" />
      <Text style={styles.infoText}>available credentials for testing:</Text>
      <Text style={styles.infoText}>test - test</Text>
      <Text style={styles.infoText}>test2 - test</Text>
      <Text style={styles.infoText}>test3 - test</Text>

      <Text style={styles.label}>Username</Text>
      <TextInput
        style={styles.input}
        value={username}
        onChangeText={setUsername}
        placeholder="Enter username"
      />
      <Text style={styles.label}>Password</Text>
      <TextInput
        style={styles.input}
        value={password}
        onChangeText={setPassword}
        placeholder="Enter password"
        secureTextEntry
      />
      {loading ? (
        <ActivityIndicator size="large" color="#00ff00" />
      ) : (
        <>
          <TouchableOpacity
            onPress={async () => {
              if (!username || !password) {
                Alert.alert('Please enter both username and password');
                return;
              }

              try {
                setLoading(true);
                await login(username, password);
              } catch (error) {
                console.error('Login failed', error);
                Alert.alert('Login failed', 'Please try again.');
              } finally {
                setLoading(false);
              }
            }}
            style={{
              width: '80%',
              padding: 20,
              backgroundColor: '#069',
              borderRadius: 8,
              alignSelf: 'center',
              alignItems: 'center',
              margin: 10,
            }}>
            <Text style={{ color: '#fff' }}>Login</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={handleSignup}
            style={{
              width: '80%',
              padding: 5,
              backgroundColor: '#069',
              borderRadius: 8,
              alignSelf: 'center',
              alignItems: 'center',
              margin: 5,
            }}>
            <Text style={{ color: '#fff' }}>Registrieren</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={handleForgotPassword}
            style={{
              width: '80%',
              padding: 5,
              backgroundColor: '#069',
              borderRadius: 8,
              alignSelf: 'center',
              alignItems: 'center',
              margin: 5,
            }}>
            <Text style={{ color: '#fff' }}>Passwort vergessen</Text>
          </TouchableOpacity>
        </>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: 20,
  },
  label: {
    fontSize: 16,
    marginBottom: 5,
    color: '#666',
  },
  infoText: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 5,
    color: '#900',
  },
  label_small: {
    fontSize: 6,
    marginBottom: 3,
    color: '#fff',
  },
  input: {
    borderWidth: 1,
    borderColor: '#ccc',
    padding: 10,
    marginBottom: 15,
    borderRadius: 5,
    fontSize: 20,
    fontWeight: 'bold',
    color: '#900',
  },
});